export default __webpack_public_path__ + "static/media/857.befb34d8.gif";